import { Outlet } from 'react-router-dom';
import { useEffect, useState, createContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import LoadingBackdrop from 'app/shared-components/layout/LoadingBackdrop';
import { selectClientById } from 'app/store/clientsSlice';
import { fetchUserSettings, selectUserSettings } from 'app/store/userSettingsSlice';
import { selectUser } from 'app/store/userSlice';
import { fetchSystemTemplates, fetchUserTemplates } from 'app/store/recordTemplatesSlice';
import { fetchSystemEnums, fetchUserEnums } from 'app/store/recordEnumsSlice';
import { useClientApp } from 'app/shared-components/client/ClientAppContext';
import withReducer from 'app/store/withReducer';
import reducer from '../../../main/apps/clients/store';

export const ClientAppContext = createContext({});

function ManageClientContent() {
  const dispatch = useDispatch();
  const routeParams = useParams();
  const location = useLocation();
  const { clientId } = routeParams;
  const client = useSelector(selectClientById(clientId));
  const user = useSelector(selectUser);
  const userSettings = useSelector(selectUserSettings);
  const recordsEnabled = true;
  const { ownerKey } = useClientApp();

  // Load user settings and templates on mount
  useEffect(() => {
    const initializeData = async () => {
      await dispatch(fetchUserSettings());
      await dispatch(fetchSystemTemplates());
      await dispatch(fetchSystemEnums());
      if (ownerKey) {
        await dispatch(fetchUserTemplates(ownerKey));
        await dispatch(fetchUserEnums(ownerKey));
      }
    };
    
    initializeData();
  }, [dispatch, ownerKey]);

  if (!client) return null;
  
  return (
    <ClientAppContext.Provider
      value={{ recordsEnabled }}
    >
      <div className="flex flex-auto justify-center h-full w-full mx-auto">
        <LoadingBackdrop />
        <Outlet context={[false, false]} />
      </div>
    </ClientAppContext.Provider>
  );
}

export default withReducer('clientsApp', reducer)(ManageClientContent);